import "url-search-params-polyfill";

export const getURLParams = () => (
  new URLSearchParams(window.location.search)
);

export const stringifyURLParams = (parameters) => {
  const paramsInstance = new URLSearchParams()
  Object.entries(parameters).forEach((entry) => paramsInstance.append(entry[0], entry[1]))
  return paramsInstance.toString()
}

const greenhouseShortRegex = /^http:\/\/grnh\.se\/([a-z|0-9]{1,})$/i
const greenhouseRegex = /^https?:\/\/(?:boards.(greenhouse).io)\/([a-z0-9_-]{1,})(?:\?gh_src=([a-z|0-9]*))?\/?$/i
const leverRegex = /^https?:\/\/(?:jobs.(lever).co)\/([^\/]{1,})\/?$/i

export const isGreenhouseShortURL = (url) => {
  return greenhouseShortRegex.test(url)
}

export const getAtsDataFromURL = (url) => {
  if (url) {
    if (isGreenhouseShortURL(url)) {
      const groups = url.match(greenhouseShortRegex)

      return { provider: 'greenhouse', username: undefined, referral: groups[1] }
    }

    const tests = [
      greenhouseRegex,
      leverRegex,
    ]

    const match = tests.find(test => test.test(url))

    const groups = url.match(match)

    return { provider: groups[1], username: groups[2], referral: groups[3] }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/lib/url.js